import { render, staticRenderFns } from "./loadingSpinner.vue?vue&type=template&id=0840001a&scoped=true"
import script from "./loadingSpinner.vue?vue&type=script&lang=js"
export * from "./loadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./loadingSpinner.vue?vue&type=style&index=0&id=0840001a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0840001a",
  null
  
)

export default component.exports